// extracted by mini-css-extract-plugin
module.exports = {"container":"Patient_container__agzB0"};